var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.9999V19.9999H2V17.9999C2 17.9999 2 13.9999 9 13.9999C16 13.9999 16 17.9999 16 17.9999ZM12.5 8.49994C12.5 7.80771 12.2947 7.13102 11.9101 6.55544C11.5256 5.97987 10.9789 5.53127 10.3394 5.26636C9.69985 5.00146 8.99612 4.93214 8.31718 5.06719C7.63825 5.20224 7.01461 5.53558 6.52513 6.02507C6.03564 6.51455 5.7023 7.13819 5.56725 7.81712C5.4322 8.49606 5.50152 9.19979 5.76642 9.83933C6.03133 10.4789 6.47993 11.0255 7.0555 11.4101C7.63108 11.7947 8.30777 11.9999 9 11.9999C9.92826 11.9999 10.8185 11.6312 11.4749 10.9748C12.1313 10.3184 12.5 9.4282 12.5 8.49994Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5962 10.6571C18.0442 10.6571 17.5962 11.1048 17.5962 11.6571V12.6571H16.5962C16.0442 12.6571 15.5962 13.1048 15.5962 13.6571C15.5962 14.2094 16.0442 14.6571 16.5962 14.6571H17.5962V15.6571C17.5962 16.2094 18.0442 16.6571 18.5962 16.6571C19.1482 16.6571 19.5962 16.2094 19.5962 15.6571V14.6571H20.5962C21.1482 14.6571 21.5962 14.2094 21.5962 13.6571C21.5962 13.1048 21.1482 12.6571 20.5962 12.6571H19.5962V11.6571C19.5962 11.1048 19.1482 10.6571 18.5962 10.6571Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterContactIcon);
export default __webpack_public_path__ + "static/media/register_contact_icon.a6807eaa.svg";
export { ForwardRef as ReactComponent };